import { LookupOfSystemInt32 } from '../../generated/auth/models/Sasfin/Wealth/Online/BL/Models/lookup-of-system-int-32';

export interface IRiskTolerancesState {
  list: LookupOfSystemInt32[];
  isLoading: boolean;
}

export const initialUIState: IRiskTolerancesState = {
  list: [],
  isLoading: false,
};
